import gql from 'graphql-tag';

import credentialOAuthFragment from './credentialOAuthFragment';
import credentialDesktopFragment from './credentialDesktopFragment';

export const credentialFragment = gql`
  fragment credentialFragment on Credential {
    dokkioClass
    id
    accountID
    dokkioUserID
    credentialType
    errorCode
    errorStatus
    errorUpdatedAt
    rowCreatedAt
    remoteItemCacheCount
    credentialOAuth {
      ...credentialOAuthFragment
    }
    credentialDesktop {
      ...credentialDesktopFragment
    }
  }
  ${credentialOAuthFragment}
  ${credentialDesktopFragment}
`;
export default credentialFragment;
